import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Store from "logic/local-storage/Store";
import { StatusIcon } from "components/common";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./Routes";
import { toMimecastInputCreateRequest } from "./formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      padding: 5px;

      :nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong {
      ::after {
        content: ':';
        margin-right: 5px;
      }
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a, _b;
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.mimecastThrottleEnabled) == null ? void 0 : _a.value);
  const storeFullMessage = !!((_b = formData.mimecastStoreFullMessage) == null ? void 0 : _b.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toMimecastInputCreateRequest(formData),
    urlWithEventHubParams
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to save your Input, please try again in a few moments.")
  } : null;
  useEffect(() => {
    if (saveInput.error) {
      setSaveInput(null);
    }
  }, [saveInput.error, setSaveInput]);
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.Mimecast.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Save and Start Input",
      loading: saveInput.loading,
      error: formError,
      description: "Check out everything below to make sure it's correct, then click the button below to complete your Mimecast setup!"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, "Input Configuration"), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Name: "), /* @__PURE__ */ React.createElement("span", null, formData.mimecastName.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Client ID: "), /* @__PURE__ */ React.createElement("span", null, formData.clientId.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Subscribed To: "), /* @__PURE__ */ React.createElement("span", null, formData.contentTypes.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Enable Throttling: "), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Store Full Message: "), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: storeFullMessage })))))
  );
};
export default StepReview;
